/* LSL · Fiche produit C, compléments (balisage : snippets/lsl-cb.liquid, lsl-cb-sim.liquid, lsl-cb-cmp.liquid ; styles : lsl-cb2.css).
   - Avis : la section « avis de la boutique » (100 avis, filtres, pagination, photos et vidéos) est reprise ici, photos et vidéos d'abord.
   - Coffret : le coffret interactif d'origine (lsl-box-explorer, 5 points) est repris ici.
   - FAQ : la FAQ d'origine est reprise ici, habillée comme sur l'accueil.
   - Carrousels à flèches, simulateur (effets de lame SNPIXEL 4.0 et effets de combat), carte de l'offre.
   Compte à rebours de l'offre : seulement si la date de fin (Paramètres du thème > LSL · Offre fiche produit) contient un jour et un mois, ex. « jusqu'au 30 novembre inclus ». */
(() => {
  'use strict';
  const root = document.querySelector('[data-lsl-cb]');
  if (!root) return;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const esc = t => String(t).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const main = root.closest('.shopify-section') || document;
  const handle = root.dataset.handle || '';
  const smooth = () => (matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth');

  /* ---------- Avis : photos et vidéos d'abord, ceux du produit avant les autres ---------- */
  function reviews() {
    const slot = $('[data-lsl-cb-reviews]', root); if (!slot) return;
    const sel = $('lsl-review-selection');
    if (!sel) { slot.classList.add('lsl-cb-gone'); return; }
    const grid = $('.lsl-reviews__grid', sel);
    if (grid) {
      const rank = c => {
        const a = $('.lsl-review__footer a', c);
        let p = ''; try { p = a ? new URL(a.getAttribute('href'), location.href).pathname : ''; } catch (_) {}
        const media = !!$('[data-review-media]', c), video = !!$('[data-media-type="video"]', c);
        return (media ? 0 : 4) + (handle && p.endsWith('/products/' + handle) ? 0 : 2) + (video ? 0 : 1);
      };
      $$('[data-review-card]', grid).map((c, i) => ({ c, i, r: rank(c) })).sort((a, b) => a.r - b.r || a.i - b.i).forEach(x => grid.append(x.c));
    }
    slot.append(sel); /* le composant se relance à l'insertion et reprend les avis dans le nouvel ordre */
  }

  /* ---------- Coffret interactif ---------- */
  function coffret() {
    const slot = $('[data-lsl-cb-box]', root), ex = $('lsl-box-explorer');
    if (slot && ex) { slot.replaceChildren(ex); slot.classList.add('has-explorer'); }
  }

  /* ---------- FAQ ---------- */
  function faq() {
    const slot = $('[data-lsl-cb-faq2]', root); if (!slot) return;
    const f = $('.lsl-native-faq'), sec = slot.closest('section');
    if (!f) { sec.classList.add('lsl-cb-gone'); if (sec.previousElementSibling) sec.previousElementSibling.classList.add('lsl-cb-gone'); return; }
    slot.append(f);
  }

  /* ---------- Carrousels à flèches ---------- */
  function carousels() {
    $$('[data-lsl-car]', root).forEach(c => {
      const t = $('[data-lsl-car-track]', c); if (!t) return;
      const prev = $('[data-lsl-car-step="-1"]', c), next = $('[data-lsl-car-step="1"]', c);
      const upd = () => { if (prev) prev.disabled = t.scrollLeft < 4; if (next) next.disabled = t.scrollLeft + t.clientWidth >= t.scrollWidth - 4; };
      c.addEventListener('click', e => { const b = e.target.closest('[data-lsl-car-step]'); if (b) t.scrollBy({ left: +b.dataset.lslCarStep * t.clientWidth * 0.85, behavior: smooth() }); });
      t.addEventListener('scroll', () => requestAnimationFrame(upd), { passive: true });
      addEventListener('resize', upd); upd();
    });
  }

  /* ---------- Simulateur : effets de lame et de combat ---------- */
  function sim() {
    const s = $('.lsl-sim', root); if (!s) return;
    const RGB_OK = ['stable', 'pulse', 'ghost'];
    const FX = {
      clash: { d: 450, snd: 'impact', t: 'Clash : la lame flashe au choc.' },
      swing: { d: 1450, snd: 'swing', t: 'Smooth Swing : le son suit la vitesse de ton geste.' },
      blaster: { d: 420, snd: 'impact', t: 'Blaster : un tir renvoyé laisse un éclat sur la lame.' },
      lockup: { d: 1700, snd: 'impact', t: 'Lock-up : deux lames bloquées l’une contre l’autre.' },
      stab: { d: 650, snd: 'impact', t: 'Estoc : la pointe flashe (NeoPixel et Proffie).' },
      melt: { d: 2000, snd: 'swing', t: 'Melt : la pointe chauffe comme si elle fondait le métal (NeoPixel et Proffie).' }
    };
    const srcs = $$('[data-sim-src]', s), sel = $('[data-sim-profile]', s);
    const src = () => srcs[+(sel && sel.value) || 0] || srcs[0];
    let cur = null; const timers = {};
    const play = kind => {
      if (s.classList.contains('is-muted')) return;
      const u = src() && src().dataset[kind]; if (!u) return;
      if (cur) cur.pause();
      cur = new Audio(u); cur.volume = 0.55;
      const p = cur.play(); if (p) p.catch(() => {});
    };
    const say = t => { const p = $('[data-sim-status]', s); if (p) p.textContent = t; };
    const on = () => new Promise(res => {
      if (s.classList.contains('is-on')) return res();
      const b = $('.mq-sim__power[data-sim-power]', s) || $('[data-sim-power]', s);
      if (b) b.click();
      setTimeout(res, 650);
    });
    s.addEventListener('click', async e => {
      const b = e.target.closest('[data-lsl-fx],[data-lsl-style]'); if (!b) return;
      if (b.dataset.lslFx) {
        const k = b.dataset.lslFx, f = FX[k]; if (!f) return;
        await on();
        if (k === 'blaster') s.style.setProperty('--bt', (15 + Math.random() * 60).toFixed(0) + '%');
        const cls = 'is-' + k;
        s.classList.remove(cls); void s.offsetWidth; s.classList.add(cls);
        clearTimeout(timers[k]); timers[k] = setTimeout(() => s.classList.remove(cls), f.d);
        play(f.snd); say(f.t);
        b.classList.remove('is-hit'); void b.offsetWidth; b.classList.add('is-hit');
        return;
      }
      const st = b.dataset.lslStyle;
      s.dataset.style = st; s.dataset.rgbStyle = RGB_OK.includes(st) ? st : 'stable';
      $$('[data-lsl-style]', s).forEach(x => x.setAttribute('aria-pressed', String(x === b)));
      const name = b.textContent.trim();
      $$('[data-lsl-style-name]', s).forEach(x => { x.textContent = 'Effet : ' + name; });
      await on();
      say('Effet de lame : ' + name + (RGB_OK.includes(st) ? ', sur les trois versions.' : ', sur le NeoPixel et le Proffie (la RGB reste stable).'));
    });
  }

  /* ---------- Carte de l'offre et compte à rebours Noël ---------- */
  /* Aperçu d'une autre date : ajouter ?lsl_now=2026-12-03 à l'adresse de la fiche (n'affecte que l'affichage). */
  const OFF = (() => { const p = new URLSearchParams(location.search).get('lsl_now'); const t = p ? Date.parse(p + (p.length <= 10 ? 'T12:00:00' : '')) : NaN; return isNaN(t) ? 0 : t - Date.now(); })();
  const nowMs = () => Date.now() + OFF;
  const MONTHS = ['janvier', 'fevrier', 'mars', 'avril', 'mai', 'juin', 'juillet', 'aout', 'septembre', 'octobre', 'novembre', 'decembre'];
  /* Jour et mois écrits en toutes lettres (« 30 novembre ») → fin de ce jour-là, passée ou non */
  function parseDate(txt) {
    const m = (txt || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').match(/(\d{1,2})(?:er)?\s+(janvier|fevrier|mars|avril|mai|juin|juillet|aout|septembre|octobre|novembre|decembre)/);
    if (!m) return null;
    /* L'année la plus proche d'aujourd'hui : « 30 novembre » vu en janvier = le 30 novembre passé, pas celui de la fin d'année */
    const now = nowMs(), y = new Date(now).getFullYear(), mi = MONTHS.indexOf(m[2]);
    return [y - 1, y, y + 1].map(yy => new Date(yy, mi, +m[1], 23, 59, 59)).sort((a, b) => Math.abs(a - now) - Math.abs(b - now))[0];
  }
  const parseEnd = txt => { const d = parseDate(txt); return d && d > nowMs() ? d : null; };
  const left = end => {
    let s = Math.max(0, Math.floor((end - nowMs()) / 1000));
    const d = Math.floor(s / 86400); s %= 86400;
    const h = Math.floor(s / 3600), mn = Math.floor((s % 3600) / 60);
    return (d ? d + ' j ' : '') + String(h).padStart(2, '0') + ' h ' + String(mn).padStart(2, '0') + ' min';
  };
  function offer() {
    const pi = $('.product-info', main); if (!pi) return;
    const data = $('#lsl-pc-data');
    const parts = ((data && data.dataset.offer) || '').split(' · ');
    const deadline = parts.slice(1).join(' · ');
    const bmDate = parseDate(deadline);
    const end = parseEnd(deadline);
    /* Offre datée et terminée : plus de nom d'événement ni de compte à rebours */
    const tag = (bmDate && !end) ? 'Offre du moment' : (parts[0] || 'Offre du moment');
    const short = root.dataset.short || '';
    const VN = { rgb: 'RGB', neo: 'NeoPixel', proffie: 'Proffie' };
    /* Version lue sur le bouton radio coché du bloc d'achat (source de vérité), pas sur une copie */
    const vkey = () => {
      const i = $('.lsl-version-selector input[type="radio"]:checked', pi);
      const l = i && ((i.labels && i.labels[0]) || i.closest('label'));
      const t = ((l && l.textContent) || '').toLowerCase();
      return /proffie/.test(t) ? 'proffie' : /neo/.test(t) ? 'neo' : /rgb/.test(t) ? 'rgb' : (document.documentElement.dataset.version || '');
    };
    let busy = false;
    const paint = () => {
      if (busy) return; busy = true;
      try {
        const bars = $('.kaching-bundles__bars', pi), head = $('.lsl-pc-ohead', pi);
        if (!bars || !head) return;
        const single = $$('.kaching-bundles__bar', bars).length === 1;
        bars.classList.toggle('lsl-of-single', single);
        pi.classList.add('lsl-of-on');
        let ns = 0, nsup = 0;
        $$('.kaching-bundles__upsell', bars).forEach(u => {
          const t = $('.kaching-bundles__upsell__text', u); if (!t) return;
          const raw = (t.getAttribute('data-lsl-t') || t.textContent).replace(/[\u{1F000}-\u{1FAFF}\u{2600}-\u{27BF}\u{FE0F}]/gu, '').replace(/\bOFFERTS?\b/gi, '').replace(/\s+/g, ' ').trim();
          const low = raw.toLowerCase(); let lab = raw;
          if (/support/.test(low)) { nsup++; lab = 'Support offert · ' + raw; }
          else if (/sabre|rk1/.test(low)) { ns++; lab = 'Sabre de combat offert n°' + ns + ' · ' + raw; }
          if (t.getAttribute('data-lsl-of') !== lab) t.setAttribute('data-lsl-of', lab);
        });
        const n = ns + nsup, pl = n > 1 ? 's' : '';
        const short1 = [ns ? ns + (ns > 1 ? ' sabres' : ' sabre') : '', nsup ? nsup + ' support' : ''].filter(Boolean).join(' + ');
        const long1 = [ns ? ns + (ns > 1 ? ' sabres de combat' : ' sabre de combat') : '', nsup ? nsup + ' support' : ''].filter(Boolean).join(' et ');
        const pr = $('.product-info__price sale-price', pi);
        const price = pr ? pr.textContent.replace(/^[^\d]*/, '').trim() : '';
        const v = VN[vkey()] || '';
        const html = '<b class="lsl-of__h">Ton offre du moment</b><div class="lsl-of__card"><span class="lsl-of__pill">' + esc(tag) + (short1 ? ' · ' + esc(short1) + ' offert' + pl : '') + '</span>' +
          (end ? '<span class="lsl-of__end">' + esc(deadline) + ' · encore <span data-lsl-of-left>' + left(end) + '</span></span>' : '') +
          (single ? '<div class="lsl-of__main"><div><b>1 réplique ' + esc(short) + (v ? ' · ' + v : '') + '</b>' + (long1 ? '<small>+ ' + esc(long1) + ' offert' + pl + '</small>' : '') + '</div><strong>' + esc(price) + '</strong></div>' : '') + '</div>';
        if (!$('.lsl-of__card', head) || head.dataset.lslOf !== html) { head.dataset.lslOf = html; head.innerHTML = html; }
        const fs = $('.lsl-pc-ofoot > span', pi);
        if (fs && fs.firstChild && fs.firstChild.nodeType === 3 && !/avec ta/.test(fs.firstChild.textContent)) fs.firstChild.textContent = 'Valeur offerte avec ta réplique ';
      } finally { busy = false; }
    };
    let raf = 0;
    new MutationObserver(() => { cancelAnimationFrame(raf); raf = requestAnimationFrame(paint); }).observe(pi, { subtree: true, childList: true, characterData: true });
    document.addEventListener('change', () => setTimeout(paint, 80));
    paint(); setTimeout(paint, 2500);
    if (end) setInterval(() => { const x = $('[data-lsl-of-left]', pi); if (x) x.textContent = left(end); }, 30000);

    /* Compte à rebours Noël : de la fin de l'offre datée (sinon du 1er décembre) jusqu'au dernier jour de commande */
    const xEnd = parseDate(data && data.dataset.xmas);
    if (xEnd) {
      const start = bmDate || new Date(xEnd.getFullYear(), 11, 1);
      const n = nowMs();
      if (n >= start && n < xEnd) {
        const day = (data.dataset.xmas || '').trim();
        const txt = (data.dataset.xmasText || 'Pour le recevoir avant Noël, commande au plus tard le [date]').replace(/\[date\]/g, day);
        const box = document.createElement('div');
        box.className = 'lsl-xmas'; box.setAttribute('role', 'note');
        box.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 12v9H4v-9M2 7h20v5H2zM12 21V7M12 7H7.5a2.5 2.5 0 1 1 0-5C11 2 12 7 12 7zM12 7h4.5a2.5 2.5 0 1 0 0-5C13 2 12 7 12 7z"/></svg><div><p class="lsl-xmas__t">' + esc(txt) + '</p><p class="lsl-xmas__left">Plus que <b data-lsl-xmas-left>' + left(xEnd) + '</b></p></div>';
        pi.append(box);
        const tick = () => { const b = $('[data-lsl-xmas-left]', box); if (nowMs() >= xEnd) { box.remove(); return; } if (b) b.textContent = left(xEnd); };
        setInterval(tick, 30000);
      }
    }
  }

  const run = () => { reviews(); coffret(); faq(); carousels(); sim(); offer(); root.classList.add('is-ready2'); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
